module.exports = __webpack_public_path__ + "static/media/1000prinny.45da130b.gif";